// src/components/UnderConstruction.tsx

const UnderConstruction = () => (
    <img src="/UnderConstruction.png"></img>
)
export default UnderConstruction;
